
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["stroke",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"51.353","height":"50.548"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 274"}},[_c('path',{attrs:{"data-name":"Path 536","d":"M38.47 42.815c-.21.209-.418.418-.636.62-.128.12-.266.249-.4.37-.2.185-.4.354-.611.523-.233.2-.474.386-.724.571-.21.16-.427.322-.645.467-.128.1-.265.193-.4.281-.257.169-.514.338-.78.5-.305.185-.6.362-.917.523s-.619.33-.932.483-.636.3-.966.435a20.765 20.765 0 01-2.984 1.013c-.3.081-.6.153-.9.217-.41.088-.82.161-1.239.225-.257.041-.514.081-.78.105a20.652 20.652 0 01-2.559.153 21.747 21.747 0 010-43.493h.041V27.35z","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"2.5"}}),_c('path',{staticClass:"hover-fill",attrs:{"data-name":"Path 537","d":"M49.084 26.623a21.616 21.616 0 01-6.264 15.461L27.4 26.616h21.677z","fill":"#707070"}}),_c('g',{attrs:{"data-name":"Group 253","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"2.5"}},[_c('path',{attrs:{"data-name":"Path 538","d":"M50.095 22.63c-.91 0-21.695.16-21.695.16V1.25a21.783 21.783 0 0110.023 2.469c.01 0 .011.011.016.007A21.847 21.847 0 0150.095 22.63z"}}),_c('path',{attrs:{"data-name":"Line 28","d":"M33.942 1.987L28.4 7.537"}}),_c('path',{attrs:{"data-name":"Line 29","d":"M38.447 3.732L28.4 13.787"}}),_c('path',{attrs:{"data-name":"Line 30","d":"M42.203 6.218L28.4 20.045"}}),_c('path',{attrs:{"data-name":"Line 31","d":"M45.292 9.379L31.867 22.82"}}),_c('path',{attrs:{"data-name":"Line 32","d":"M47.738 13.176l-9.669 9.693"}}),_c('path',{attrs:{"data-name":"Line 33","d":"M49.451 17.72l-5.14 5.148"}})])])])
          )
        }
      }
    